export const defaultClipartMeasurementValue = () => {
    return {
        styles: { width: 500, height: 500},
        drop_on_clipart: false,
        clipart: null,
        clipart_styles: { x: 0, y: 0},
        // answer: null,
        multi_clipart: null,
        num_images: 0,
        properties: [],
        hollow_styles: {height: 100, width: 100, x:0, y:0}
    }
}